module.exports = __webpack_public_path__ + "img/kazakhstan.4d46f330.svg";